module.exports = __webpack_public_path__ + "c1ba51a0f45dbce5618b7e9b65cfcc06.svg";